import React from 'react';
import pt from 'prop-types';

import Link from 'components/link';
import Table from 'components/collection/table';
import AppIcon from 'components/apps/icon';
import Status from 'components/status';
import { inflect } from 'utils';
import { getAppDisplayId, renderAppTypeLabel } from 'utils/app';

const FIELDS = [
  {
    type: 'image',
    url: '/apps/{id}',
    func: (app) => <AppIcon image={app.logo_icon} name={app.name} size={48} />,
  },
  {
    func: (app) => (
      <div>
        <Link to={`/apps/${app.id}`} className="collection-table-title">
          {app.name}
        </Link>
        <div className="collection-table-subtitle">{getAppDisplayId(app)}</div>
      </div>
    ),
  },
  {
    func: (app) => renderAppTypeLabel(app.type),
  },
  {
    func: () => <Status type="positive">Published</Status>,
  },
  {
    path: 'version',
  },
  {
    func: (app) => inflect(app.versions?.count || 0, 'version'),
  },
  {
    func: (app) => inflect(app.installs?.count || 0, 'install'),
  },
];

export default function PartnerApps({ apps }) {
  return (
    <Table
      title="Apps"
      titleCount={false}
      subtitle="Published apps are shown on your partner profile"
      emptyMessage="No published apps yet"
      fields={FIELDS}
      rows={apps}
    />
  );
}

PartnerApps.propTypes = {
  apps: pt.array,
};
